import { metaChart } from "@/designSystemIcons";
import { cn } from "@/lib/utils";
import { BREAKPOINTS } from "@/settings";
import { useTranslation } from "@repo/shared/i18n";
import React from "react";
import { useMediaQuery } from "usehooks-ts";

const ratingValues = [
  {
    id: 1,
    rating: "S",
    ratingColor: "text-tiers-s",
    descriptionKey: "s",
  },
  {
    id: 1,
    rating: "A+",
    ratingColor: "text-tiers-a-plus",
    descriptionKey: "aPlus",
  },
  {
    id: 1,
    rating: "A",
    ratingColor: "text-tiers-a",
    descriptionKey: "a",
  },
  {
    id: 1,
    rating: "B+",
    ratingColor: "text-tiers-b-plus",
    descriptionKey: "bPlus",
  },
  {
    id: 1,
    rating: "B",
    ratingColor: "text-tiers-b",
    descriptionKey: "b",
  },
] as const;

const MetaRatingTiers: React.FC = () => {
  const { t } = useTranslation("metaRating");
  const isTouch = useMediaQuery(BREAKPOINTS.TOUCH_DEVICE.query);

  return (
    <div className={cn(isTouch ? "pt-8 pb-17 px-4 bg-gray-900-new" : "mt-14")}>
      <div
        className={cn(
          "flex items-center",
          isTouch ? "flex-col rounded mb-6 px-0" : "px-6",
        )}
      >
        <div
          className={cn(
            "flex flex-col justify-center",
            isTouch ? "w-full" : "min-w-[472px] max-w-[472px] min-h-[275px]",
          )}
        >
          <div
            className={cn(
              "text-base font-semibold text-dark-primary",
              isTouch && "text-xs",
            )}
          >
            {t("tiers.title")}
          </div>
          <div
            id="tiersDescription"
            className={cn("text-dark-tertiary text-sm", isTouch && "text-xs")}
          >
            {t("tiers.description")}
          </div>
        </div>

        {!isTouch && <div className="w-112 ml-auto mb-12">{metaChart}</div>}
      </div>

      <div
        className={cn(
          isTouch
            ? "grid grid-cols-2 gap-2"
            : "grid grid-cols-3 gap-4 items-center justify-center",
        )}
      >
        {ratingValues.map((value, i) => (
          <div
            key={i}
            className={cn(
              "w-full h-full bg-panel-background",
              isTouch
                ? "min-h-[140px] p-3 rounded"
                : "min-h-[116px] p-6 rounded-xl shadow-lg",
            )}
          >
            <div
              className={cn(
                value.ratingColor,
                isTouch
                  ? "mb-2 text-sm font-semibold"
                  : "mb-2 text-xl font-semibold",
              )}
            >
              {value.rating}
            </div>
            <div className="text-dark-tertiary text-xs">
              {t(`tiers.descriptions.${value.descriptionKey}` as const)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MetaRatingTiers;
